import React from 'react';

//PACKS
import { connect } from 'react-redux';
import { Button, Alert, Navbar, Spinner } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { Form as FinalForm } from 'react-final-form';
import { UserPin } from '@styled-icons/boxicons-regular/UserPin';
import { passwordStrength } from 'check-password-strength';

//Components
import FormNovaSenha from '../../../components/forms/logins/FormNovaSenha';

//ACTIONS
import { atualizasenha } from '../../../actions/login/login';
import { novoatualiza, atualiza as atualizadados } from '../../../actions/logingerenciamento/login';

//TOOLS
import { getTraducaoTrocaPor as trad } from '../../../utils/getTraducoes';

class NovaSenha extends React.Component {

    state = {
        atualizaDadosResult: null
    }
            
    onSubmit = async (form) => {
        let dados = {};
        let forms = {};
        switch (this.props.idcategoria) {
            case 3:
                forms = {
                    email: this.props.pesquisadadosGeren[0].email,
                    password: form.senha
                }
                dados = await this.props.atualizadados(forms);
                break;
        
            default:
                forms = {
                    idusuario: this.props.pesquisadados[0].idusuario,            
                    idpromotora: this.props.idpromotora,
                    ...form
                }        
                dados = await this.props.atualizasenha(forms)
                break;
        }

        this.setState({
            atualizaDadosResult: dados.result
        });
                
        if(dados.result===true){
            setTimeout(() => (
                this.props.handleVoltar()
            ), 5000)
        }
    }

    render(){
        
        return (
            <FinalForm 
            onSubmit={this.onSubmit}
            validate={ values => {
                const errors = {};
                if(!values.senha){
                    errors.senha = trad(this.props.trads,'ERROEMAIL1',this.props.lingua);
                }   
                
                if(values.senha){                    
                    if(values.senha.length < 6){
                        errors.senha = 'Tamanho mínimo de 6 caracteres';
                    }
                    if(passwordStrength(values.senha).id < 2){
                        errors.senha = 'Senha muito fraca, experimente símbolos e letras maiúsculas!';
                    }
                }

                return errors;
            }}
            render={({form, pristine, submitting, handleSubmit}) => (
                <form onSubmit={handleSubmit}>
                    <Navbar bg="light" expand="lg" className="justify-content-center">
                        <Navbar.Brand>{trad(this.props.trads,'Informe a nova senha',this.props.lingua)}</Navbar.Brand>
                        <UserPin size="60" />
                    </Navbar>
                    {!this.props.pendingTasks?
                    this.state.atualizaDadosResult===false?
                    <Alert variant="warning">Houve um problema na atualização da senha!</Alert>
                    :
                    this.state.atualizaDadosResult===true?
                    <Alert variant="success">Nova senha cadastrado com sucesso!</Alert>
                    :
                    null
                    :
                    null
                    }
                    <FormNovaSenha 
                    form={form}
                    {...this.props}                    
                    />
                    <Button          
                        id="btosubmit"               
                        variant="primary" 
                        size="lg" 
                        block 
                        type="submit"       
                        onClick={this.handleSubmitLog}
                        disabled={submitting || pristine}
                        >
                        {this.props.pendingTasks?
                        <Spinner animation="border"  />
                        :
                        trad(this.props.trads,'BT_AVANCAR2',this.props.lingua)
                        }
                    </Button>
                    <Button
                        variant="secondary" 
                        size="lg" 
                        block 
                        type="button"       
                        onClick={this.props.handleVoltar}                        
                        >
                        {trad(this.props.trads,'Voltar',this.props.lingua)}
                    </Button>
                </form>
            )}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        trads: state.reducerTraducoes,
        pendingTasks: state.pendingTasks,
        pesquisadados: state.pesquisaLoginReducer,
        pesquisadadosGeren: state.pesquisaloginGereReducer        
    }
}

export default connect(mapStateToProps,{atualizasenha,novoatualiza,atualizadados})(withRouter(NovaSenha));